import React from 'react'
import { css } from 'aphrodite'
import styles from './styles'
import { TagIcon } from './TagIcon'
import { Basket } from './Basket'
import TrashCan from './TrashCan'
import { Upload } from './Upload'
import { Filter } from './Filter'

export default () => (
  <div className={css(styles.container)}>
    <div>
      <TagIcon />
      <Basket />
      <TrashCan />
      <Upload />
      <Filter />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/swiftMenu.js